import API from '~config/api';

import {
  ApiPromise,
  DataPaginateResponse,
  ErrorResponse,
} from '~globals/types';

import { LogisticZoneBase, LogisticZoneMap } from './types';

export const LOGISTICS_ZONES_ENPOINTS = {
  getLogistiscZones: '/api/v1/Admin/Zone',
  getLogistiscZonesMap: '/api/v1/Route/ZoneFull',
};

export const getLogistiscZonesInfo = (): ApiPromise<
  DataPaginateResponse<LogisticZoneBase[]>,
  ErrorResponse
> =>
  API.get<DataPaginateResponse<LogisticZoneBase[]>, ErrorResponse>(
    LOGISTICS_ZONES_ENPOINTS.getLogistiscZones,
  );

export const getLogistiscZonesMap = (): ApiPromise<
  DataPaginateResponse<LogisticZoneMap[]>,
  ErrorResponse
> =>
  API.get<DataPaginateResponse<LogisticZoneMap[]>, ErrorResponse>(
    LOGISTICS_ZONES_ENPOINTS.getLogistiscZonesMap,
  );
